import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import axios from 'axios';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

const HeroCarousel = () => {
  const [slides, setSlides] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSlides();
  }, []);

  const fetchSlides = async () => {
    try {
      const response = await axios.get('/api/hero-carousel');
      setSlides(response.data);
    } catch (error) {
      console.error('Error fetching carousel:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return null; // Loading sırasında da gösterme
  }

  // Eğer görsel yoksa hiçbir şey gösterme
  if (slides.length === 0) {
    return null;
  }

  return (
    <section className="mb-16">
      <div className="w-full">
        <Swiper
          spaceBetween={30}
          centeredSlides={true}
          autoplay={{
            delay: 3500,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
          }}
          navigation={true}
          modules={[Autoplay, Pagination, Navigation]}
          className="hero-carousel rounded-xl overflow-hidden shadow-premium border-2 border-gold/30"
        >
          {slides.map((slide) => (
            <SwiperSlide key={slide.id}>
              <div 
                onClick={() => {
                  if (slide.link && slide.link !== '#') {
                    if (slide.link.startsWith('http://') || slide.link.startsWith('https://')) {
                      window.open(slide.link, '_blank', 'noopener,noreferrer');
                    } else {
                      // Internal route
                      window.location.href = slide.link;
                    }
                  }
                }}
                className={`block w-full h-64 md:h-96 ${slide.link && slide.link !== '#' ? 'cursor-pointer' : ''}`}
              >
                <img
                  src={slide.image_url && slide.image_url.startsWith('http') ? slide.image_url : slide.image_url || ''}
                  alt="Reklam"
                  className="w-full h-full object-contain bg-gradient-to-br from-navy-900 via-navy-800 to-navy-900"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        
        <style jsx>{`
          .hero-carousel .swiper-button-next,
          .hero-carousel .swiper-button-prev {
            color: #d4af37;
          }
          
          .hero-carousel .swiper-pagination-bullet {
            background: #d4af37;
          }
          
          .hero-carousel .swiper-pagination-bullet-active {
            background: #fbbf24;
          }
        `}</style>
      </div>
    </section>
  );
};

export default HeroCarousel;
